import React, { useState, useEffect } from 'react';

function ServerTime() {
  const [currentTime, setCurrentTime] = useState(new Date().toUTCString());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toUTCString());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {currentTime.replace("GMT","")}
    </>
  );
}

export default ServerTime;
